/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { DestinationTutorialExitsEntryFromJSON, DestinationTutorialExitsEntryToJSON, } from './';
export function DestinationTutorialFromJSON(json) {
    return DestinationTutorialFromJSONTyped(json, false);
}
export function DestinationTutorialFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'tutorialId': !exists(json, 'tutorial_id') ? undefined : json['tutorial_id'],
        'exits': !exists(json, 'exits') ? undefined : (json['exits'].map(DestinationTutorialExitsEntryFromJSON)),
    };
}
export function DestinationTutorialToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'tutorial_id': value.tutorialId,
        'exits': value.exits === undefined ? undefined : (value.exits.map(DestinationTutorialExitsEntryToJSON)),
    };
}
//# sourceMappingURL=DestinationTutorial.js.map